import { analyticsDashboardRoute } from '.';
import { useDashboardsQuery } from './query';

export function useDashboardRoute() {
  const { data } = useDashboardsQuery();
  const { dashboardId } = analyticsDashboardRoute.useParams();
  const dashboardPage = data?.find((d) => d.dashboards.some(({ id }) => id === dashboardId));
  const dashboards = dashboardPage?.dashboards ?? [];
  const dashboardPageTitle = dashboardPage?.title;

  return {
    dashboardPage,
    dashboardId,
    dashboards,
    dashboardPageTitle,
  };
}
